import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
import {getOptionsFromJsonString} from "../../../../default/global/js/utilities/options";

export function initSlideshows(query = document.querySelectorAll('.slideshow.swiper')) {
    for (const slideshow of query) {
        const options = getOptionsFromJsonString(slideshow.dataset.options, {
            autoplay_interval: 5000,
            eff_interval: 300,
        });
        if (slideshow.classList.contains("slideshow--3")) {
            Swiper.use([Autoplay, Pagination]);
            new Swiper(slideshow, {
                loop: true,
                items: 1,
                speed: options.eff_interval,
                autoplay: {
                    delay: options.autoplay_interval,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                }
            });
        } else {
            Swiper.use([Autoplay, Navigation, Pagination]);
            new Swiper(slideshow, {
                slidesPerView: "auto",
                loop: true,
                // loop: slideshow.querySelectorAll('.swiper-slide').length,
                watchSlidesProgress: true,
                autoplay: {
                    enabled: true,
                    delay: 5000
                },
                centeredSlides: true,
                spaceBetween: 10,
                pagination: {
                    el: slideshow.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                navigation: {
                    nextEl: slideshow.querySelector('.swiper-button-next'),
                    prevEl: slideshow.querySelector('.swiper-button-prev'),
                },
                breakpoints: {

                    768: {
                        spaceBetween: 20,

                    }
                }
            });
        }
    }
}
